import { z } from "zod";
import {
  createGetListRequestSchema,
  DomainModelMetaExtendedSchema,
  DomainModelMetaSchema,
  DomainModelSchema,
} from "../util/index.ts";

export const EventSchemaStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;
export type EventSchemaStatusType =
  (typeof EventSchemaStatus)[keyof typeof EventSchemaStatus];

export const EventAssociatedFormSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  description: z.string(),
  required: z.boolean(),
  form_category: z.object({ id: z.string().uuid(), name: z.string() }),
  form_submission_restricted_role_ids: z.array(z.string()).optional(),
});
export type EventAssociatedFormSchemaType = z.infer<
  typeof EventAssociatedFormSchema
>;

export const EventSchemaSchema = z
  .object({
    name: z.string(),
    version: z.string(),
    priority: z.string(),
    status: z.nativeEnum(EventSchemaStatus),
    description: z.string(),
    config: z.object({
      forms: z.object({
        required_templates: z.array(z.string().uuid()).optional(),
        suggested_templates: z.array(z.string().uuid()).optional(),
      }),
      due_date: z.object({
        duration: z.number(),
        time_period: z.string(),
        relative_time: z.boolean(),
      }),
      equipment: z.object({
        has_source: z.boolean(),
        is_mandatory: z.boolean(),
      }),
      has_forms: z.boolean(),
      has_alerts: z.boolean(),
      has_devices: z.boolean(),
      has_due_date: z.boolean(),
      has_equipment: z.boolean(),
    }),
    event_category_id: z.string().uuid(),
    company_id: z.string().uuid(),
    form_schemas: z.array(EventAssociatedFormSchema),
  })
  .merge(DomainModelSchema)
  .merge(DomainModelMetaSchema)
  .merge(DomainModelMetaExtendedSchema)
  .describe("Represents an Event Schema in the Node API");
export type EventSchemaType = z.infer<typeof EventSchemaSchema>;

export const EventSchemaGetListRequestSchema = createGetListRequestSchema(
  EventSchemaSchema.pick({
    id: true,
    name: true,
    description: true,
    status: true,
    version: true,
    priority: true,
    created_at: true,
    updated_at: true,
  })
    .extend({
      "event_category.id": z.string().uuid(),
      "event_category.name": z.string(),
    })
    .partial()
);
export type EventSchemaGetListRequestType = z.infer<
  typeof EventSchemaGetListRequestSchema
>;
